/**
 * For an allOf entry with then: false and if checking a single property const or enum,
 * returns that property key so the builder can omit it. Otherwise returns null.
 */
export function getOmitPropertyFromIfThenFalse(entry) {
  if (entry.then !== false) {
    return null
  }

  const ifProps = entry.if?.properties
  if (!ifProps || typeof ifProps !== 'object') {
    return null
  }

  const keys = Object.keys(ifProps)
  if (keys.length !== 1) {
    return null
  }

  const key = keys[0]
  const subSchema = ifProps[key]
  const hasConst = subSchema?.const !== undefined
  const hasEnum = Array.isArray(subSchema?.enum) && subSchema.enum.length > 0
  if (!hasConst && !hasEnum) {
    return null
  }

  return key
}
